import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);


export default class Mainvisual {
    constructor() {
        this.init();
    }

    init() {
        const trigger = document.querySelector(".js-mainvisual-trigger-scroll");
        const triggerRect = trigger.getBoundingClientRect();

        this.triggrth = trigger.clientHeight;
        this.triggertop = window.pageYOffset + triggerRect.top;

        this.hideText();
        this.fadeText();
    }

    _scrollIntro() {
        const mainImg = document.querySelector(".mainvisual__ph.-bg");

        const windowh = window.innerHeight;
        const ingh = mainImg.clientHeight;
        const diff = -(windowh - ingh);
        const diffpercentage = (diff / ingh) * 100;
        const offset = window.innerWidth / 1920;

        if (window.innerWidth >= 1280) {
            if (diffpercentage > 20) {
                gsap.to(window, {
                    duration: 1,
                    scrollTo: {
                        y: this.triggertop,
                        offsetY: offset,
                        autoKill: false,
                    },
                    ease: "circ.inOut",
                });
            }
        }
    }

    hideText() {
        const triggerElm = document.querySelector(".js-mainvisual-trigger-ph");

        ScrollTrigger.create({
            trigger: triggerElm,
            start: "top top",
            end: "bottom top",

            onLeave: () => {
                document.body.classList.add("-hidetoptxt");
            },
            onEnterBack: () => {
                document.body.classList.remove("-hidetoptxt");
            },
            once: false,
            //markers: true,
        });
    }

    fadeText() {
        const revealElm = document.querySelectorAll(".js-mainvisual-txt");
        const triggerElm = document.querySelector(
            ".js-mainvisual-trigger-scroll"
        );

        [...revealElm].forEach((el) => {
            gsap.to(el, {
                opacity: 0,
                scrollTrigger: {
                    trigger: triggerElm,
                    start: "top top",
                    //markers: true,
                    scrub: true,
                    autoKill: false,
                    onLeave: () => document.body.classList.add("-hidetop"),
                },
            });
        });
    }
    

}
